var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-container"},_vm._l((_vm.cards),function(card,index){return _c('InfoCard',{key:index,attrs:{"title":card.title,"icon":card.icon,"value":card.value,"percent":card.percent,"isloading":_vm.isloading}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }